import { useCallback, useEffect, useRef } from 'react';

/**
 * UseFixScroll .
 */
const useFixScroll = () => {
  const valueScrollY = useRef<string | null>(null);
  const smoothScrollStyle = useRef<string>('');

  const setScrollProperty = () =>
    document.documentElement.style.setProperty(
      '--scroll-y',
      `${window.scrollY}px`,
    );

  useEffect(() => {
    window.addEventListener('scroll', setScrollProperty);

    return () => {
      window.removeEventListener('scroll', setScrollProperty);
    };
  }, []);

  const handleFixScroll = useCallback((isVisible: boolean) => {
    if (isVisible) {
      const scrollY =
        document.documentElement.style.getPropertyValue('--scroll-y') || '0';

      // Save values as refs so we don't re-render
      valueScrollY.current = scrollY as string;
      smoothScrollStyle.current = document.documentElement.style.scrollBehavior;

      document.body.style.position = 'fixed';
      document.body.style.overflowY = 'scroll';
      document.body.style.right = '0';
      document.body.style.left = '0';
      document.body.style.top = `-${scrollY}`;
    } else {
      // Switch smooth scrolling off until after we readjust the scroll position
      document.documentElement.style.scrollBehavior = 'auto';

      // Set to static and adjust the scroll position
      document.body.style.position = 'static';
      document.body.style.overflowY = 'unset';
      document.body.style.right = '';
      document.body.style.left = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(valueScrollY.current || '0', 10));

      // Revert smooth scroll change
      document.documentElement.style.scrollBehavior = smoothScrollStyle.current;
    }
  }, []);

  return handleFixScroll;
};

export default useFixScroll;
